/*LIBRARY*/
import React, { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import {
  set_value_sini,
  fly_init_update,
  get_ai_parent_list,
  get_ai_child_list,
  get_ai_parent_object,
} from "../../App/actions/sini_v2";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class SINI_HISTORY_FLY extends Component {
  state = {};

  componentDidMount() {
    this.props.get_ai_parent_list();
  }

  on_click_request_id = (request_id) => {
    this.props.close_history();

    this.props.set_value_sini({
      key: "rdtr_input_OBJECTID",
      value: "",
    });

    const { ai_parent_child_list, ai_parent_detail_list } = this.props.sini;

    let request_id_active_array = this.props.sini.request_id_active_array || [];

    if (!request_id_active_array.includes(request_id)) {
      request_id_active_array.push(request_id);
      this.props.fly_init_update();
      this.props.set_value_sini({
        key: "request_id_active",
        value: request_id,
      });
    } else {
      request_id_active_array = request_id_active_array.filter(
        (item) => item !== request_id
      );
      this.props.set_value_sini({
        key: "request_id_active",
        value: "",
      });
    }

    this.props.set_value_sini({
      key: "request_id_active_array",
      value: request_id_active_array,
    });

    const ai_child_list =
      ai_parent_child_list.find((item) => item?.request_id === request_id)
        ?.ai_child_list || [];
    const sini_db_object_test = ai_parent_detail_list.find(
      (item) => item.request_id === request_id
    )?.request_id;

    const params = {
      request_id: request_id,
    };
    if (ai_child_list.length === 0) {
      this.props.get_ai_child_list(params);
    }

    if (!sini_db_object_test) {
      this.props.get_ai_parent_object(params);
    }

    this.props.set_value_sini({
      key: "is_sini_visible",
      value: true,
    });
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state

    //global props
    const { request_id_active, ai_parent_list, request_id_active_array } =
      this.props.sini;

    //content
    return (
      <main>
        {ai_parent_list.length === 0 ? (
          <div className="container background_grey_light">
            <p className="text_medium sub_color">
              {
                dict?.["You do not have any history of SINI Site Analysis"]?.[
                  language
                ]
              }
            </p>
          </div>
        ) : (
          <>
            {ai_parent_list.map((item, idx) => {
              return (
                <section
                  key={idx}
                  className="container margin_bottom button_white cursor_pointer"
                  onClick={this.on_click_request_id.bind(this, item.request_id)}
                >
                  <div className="two_container_small_left">
                    <span
                      className={`badge_circle margin_right ${
                        request_id_active_array.includes(item?.request_id)
                          ? "background_green"
                          : "background_grey"
                      }`}
                    />
                    <p className="text_left text_bold">{item?.title_1}</p>
                  </div>
                  <p className="text_small margin_bottom">{item?.title_2}</p>
                  {request_id_active === item.request_id && (
                    <>
                      <br />
                      <div className="badge background_black margin_bottom">
                        {dict?.["Displayed in the sidebar"]?.[language]}
                      </div>
                    </>
                  )}
                  <div
                    style={{
                      backgroundColor: "transparent",
                      borderTop: "2px solid #e6e6e6",
                    }}
                  />
                </section>
              );
            })}
          </>
        )}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  map: state.map,
  license_reducer: state.license_reducer,
  sini: state.sini,
  loading_reducer: state.loading_reducer,
});

export default connect(mapStateToProps, {
  set_value_sini,
  fly_init_update,
  get_ai_parent_list,
  get_ai_child_list,
  get_ai_parent_object,
})(SINI_HISTORY_FLY);
